import { useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import type { BottomSheetModalProps } from "@/ui/composed/modal/BottomSheetModal";
import BottomSheetModal from "@/ui/composed/modal/BottomSheetModal";
import { Button, Text } from "@/ui/core";
import BaseDocumentCard from "@/ui/core/BaseDocumentCard";
import { VStack } from "@/ui/layout";

const StoryMeta: Meta<BottomSheetModalProps> = {
  title: "Components/Modal/Bottom Sheet Modal",
  component: BottomSheetModal,
  argTypes: {
    dismissAccessibilityLabel: { control: "text" },
    isSmallBottomPadding: { control: "boolean" },
    onDismissAnimationEnd: { action: "dismissed" },
    onRequestClose: { action: "request close" },
    shouldRenderFloatingButton: { control: "boolean" },
    testID: { control: "text" },
    title: { control: "text" },
  },
  args: {
    dismissAccessibilityLabel: "Dismiss Bottom Sheet Modal",
    title: "Bottom Sheet Modal",
  },
  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const {
      dismissAccessibilityLabel,
      isSmallBottomPadding,
      onDismissAnimationEnd,
      onRequestClose,
      testID,
      title,
    } = args;

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleDismiss = () => {
      setIsOpen(false);
      onDismissAnimationEnd?.();
    };

    const handleRequestClose = () => {
      setIsOpen(false);
      onRequestClose();
    };

    return (
      <>
        <VStack alignItems="center" width="100%">
          <Button
            onPress={() => setIsOpen(true)}
            testID=""
            title="Open Bottom Sheet Modal"
          />
        </VStack>

        <BottomSheetModal
          dismissAccessibilityLabel={dismissAccessibilityLabel}
          isOpen={isOpen}
          isSmallBottomPadding={isSmallBottomPadding}
          onDismissAnimationEnd={handleDismiss}
          onRequestClose={handleRequestClose}
          testID={testID}
          title={title}
        >
          <VStack gap={12}>
            <Text testID="" variant="bodyMedium">
              Recommended for you
            </Text>
            <Text testID="">
              Did you know Equip is one of the leading researchers in the Eating
              Disorder industry ?The following article walks through some of our
              recent work helping build treatments that work.
            </Text>
            <BaseDocumentCard
              fileDisplayName="Equip Research"
              fileName="equip-research.pdf"
              id=""
              testID=""
            />
          </VStack>
        </BottomSheetModal>
      </>
    );
  },
};
type Story = StoryObj<BottomSheetModalProps>;

export default StoryMeta;
export const Primary: Story = {};
